import CloseIcon from 'svg/CloseIcon';
import { ButtonText } from 'components/Button';
import FormCreateAccountReminder from 'components/forms/FormCreateAccountReminder';
import Modal from 'components/modals/Modal';

export interface Props {
  isOpen: boolean;
  handleClose: (value: boolean) => void;
  handleSignupSuccess?: ({ userId }: { userId: string }) => void | Promise<void>;
  shouldSkipReload?: boolean;
  handleAuthComplete?: () => void;
}

export default function ModalCreateAccountReminder({
  isOpen,
  handleClose,
  handleSignupSuccess,
  shouldSkipReload,
  handleAuthComplete,
}: Props) {
  return (
    <Modal
      isOpen={isOpen}
      handleClose={() => handleClose(true)}
      classNameMaxWidth="sm:max-w-md lg:max-w-[40rem]"
    >
      {/*
        Rendered before the form so Headless UI's default "focus the
        first focusable descendant" behavior lands here instead of
        on the sport pill toggle inside the form.
      */}
      <ButtonText
        size="icon"
        className="absolute right-2 top-3 rounded-full bg-color-bg-lightmode-primary p-2 text-color-text-lightmode-primary transition-colors hover:bg-brand-gray-50 dark:bg-color-bg-darkmode-primary dark:text-color-text-darkmode-primary lg:right-8 lg:top-4"
        onClick={() => handleClose(true)}
      >
        <span className="sr-only">Close</span>
        <CloseIcon className="h-6 w-6" aria-hidden="true" />
      </ButtonText>
      <FormCreateAccountReminder
        handleSignupSuccess={handleSignupSuccess}
        shouldSkipReload={shouldSkipReload}
        handleAuthComplete={handleAuthComplete}
      />
    </Modal>
  );
}
